'use client';

import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { Button } from 'src/general/components/Button/Button';
import { CarKeyInformation } from 'src/pdp/components/CarKeyInformation/CarKeyInformation';
import { pdpStore } from 'src/stores/pdpStore';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

import { formatSpecs } from '../Pdp/pdpHelpers';

type Props = {
  productDetails: ProductDetailsPayload;
};

export const Specs: FC<Props> = ({ productDetails }) => {
  const { setCurrentModal } = pdpStore(
    ({ setCurrentModal }) => ({
      setCurrentModal,
    }),
    shallow,
  );

  const carProps = formatSpecs(productDetails);

  const handleOpenModal = () => {
    setCurrentModal({ name: 'features', initialTab: 'specifications' });
    pushToDataLayer({
      event: 'pdp_interaction',
      type: 'modal',
      value: 'view_all_specs',
    });
  };

  const numOfSpecs = Object.values(carProps.carSummary).filter((val) => !!val).length;

  if (numOfSpecs === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-8 pb-14">
      <header>
        <h3 className="c-fs-h5 font-extrabold">Specs</h3>
      </header>

      <CarKeyInformation {...carProps} />

      <footer>
        <Button variant="secondary" size="small" onClick={handleOpenModal} data-testid="Specs-viewAll">
          View all specs
        </Button>
      </footer>
    </section>
  );
};
